import {SagaIterator} from 'redux-saga';
import {put, takeEvery} from 'redux-saga/effects';

import {ActionType} from 'types/reducers';

import {sendPayerInfoToSaga} from '../../reducers/paymentStep/payerInfo/payerInfo';
import {
    changeLoadingSavePayment,
    savePaymentMethod,
} from '../../reducers/paymentStep/paymentMethodSave/paymentMethodSave';

/**
 * savePayment
 */
export function* savePayment({
    payload: {id, method, token},
}: ActionType<{token: string; method: string; id?: string}>): SagaIterator {
    yield put(changeLoadingSavePayment(true));
    yield put(
        sendPayerInfoToSaga({
            id,
            method,
            token,
        }),
    );
}

/**
 * Saga for GooglePay and PayPal flow
 * */
export function* savePaymentMethodSaga(): SagaIterator {
    yield takeEvery(`${savePaymentMethod}`, savePayment);
}
